




















































































































































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import moment from 'moment';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  CellValueChangedEvent,
  ValueFormatterParams,
} from 'ag-grid-community';
import store from '@/store';
import config from '@/config/index';

import { LoadingService } from '@/services/loadingService';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import ChipAplication from './reusables/ChipAplication.vue';
import CardInformativa from './reusables/CardInformativa.vue';
import { AgGridVue } from 'ag-grid-vue';
import PanelInfo from './reusables/PanelInfo.vue';
import CarrouselInformativa from './reusables/CarrouselInformativa.vue';
import { string } from 'yup';
import { fetchDashboard } from '@/pantallas/Dashboard/fetchDashboard';
import { Funcionalidades } from '@/config/funcionalidades';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
import { filtroHomeEventBus, filtroHomeEvents } from '@/setup';
import ModalActualizarDatos from './ModalActualizarDatos.vue';
import { fetchMS, fetchMSGeneral } from './reusables/fetchMS';
// import * as process from "process";

@Component({
  components: {
    MantenedorGrid,
    AgGridVue,
    'chip-app': ChipAplication,
    informacion: CardInformativa,
    panelInfo: PanelInfo,
    CarrouselInformativa,
    ModalActualizarDatos,
  },
})
export default class HomeGenerico extends Vue {
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  search: string = '';
  $snotify: any;
  color: string = 'azul';
  txtFooter: string = 'Sea cual sea tu objetivo, tenemos la solución.';
  muestraInformacion: boolean = false;
  urldashboard: string =
    'https://us-east-1.signin.aws.amazon.com/oauth?SignatureVersion=4&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAIYOJP4OBNT7XFVSQ&X-Amz-Date=2022-06-29T17%3A51%3A01.025Z&X-Amz-Signature=f71174b578d4cf27755abe4b3420d8232ac2bdada14af1452df4e82af0d3a4d7&X-Amz-SignedHeaders=host&client_id=arn%3Aaws%3Aiam%3A%3A015428540659%3Auser%2Fspaceneedle-prod&enable-sso=&forceMobileApp=0&qs-signin-user-auth=&response_type=code&redirect_uri=https%3A%2F%2Fus-east-2.quicksight.aws.amazon.com%2Fsn%2Fstart%3Fdirectory_alias%3DGpschile%26edap%3Dtrue%26state%3DhashArgs%2523%26isauthcode%3Dtrue&qs-signin-account-name=Gpschile&directory_alias=Gpschile&rdfs=true';
  cantMsj: number = 1;
  elementosInformacion: any = [];
  usuario: any = this.$store.state.user;
  mostrarTrack: boolean = false;
  mostrarAlertas: boolean = false;
  mostrarCamaras: boolean = false;
  mostrarCosecha: boolean = false;
  mostrarDashboard: boolean = false;
  mostrarDirector: boolean = false;
  mostrarMobileye: boolean = false;
  mostrarOrvis: boolean = false;
  mostrarPeajes: boolean = false;
  mostrarRoutePlanner: boolean = false;
  mostrarVigilanti: boolean = false;
  mostrarMultiflota: boolean = false;
  mostrarAnglo: boolean = false;
  mostrarVendimia: boolean = false;
  mostrarAvlTrack: boolean = false;
  permisosAlertas: any = {
    funcionalidad: Funcionalidades.Alertas,
    codigoAccion: CodigoAccion.Consultar,
  };
  permisosCosecha: any = {
    funcionalidad: Funcionalidades.HomeSugal,
    codigoAccion: CodigoAccion.Consultar,
  };
  permisosDashboard: any = {
    funcionalidad: Funcionalidades.DashboardEsmax,
    codigoAccion: CodigoAccion.Consultar,
  };
  permisosCamaras: any = {
    funcionalidad: Funcionalidades.CamarasDashboard,
    codigoAccion: CodigoAccion.Consultar,
  };
  permisosVigilanti: any = {
    funcionalidad: Funcionalidades.AlertasVigilanti,
    codigoAccion: CodigoAccion.Consultar,
  };
  permisosRoutePlanner: any = {
    funcionalidad: Funcionalidades.RoutePlanner,
    codigoAccion: CodigoAccion.Consultar,
  };
  permisosTrack: any = {
    funcionalidad: Funcionalidades.Inicio,
    codigoAccion: CodigoAccion.Consultar,
  };
  permisosOrvis: any = {
    funcionalidad: Funcionalidades.Orvis,
    codigoAccion: CodigoAccion.Consultar,
  };
  permisosDirector: any = {
    funcionalidad: Funcionalidades.Director,
    codigoAccion: CodigoAccion.Consultar,
  };
  permisosMobileye: any = {
    funcionalidad: Funcionalidades.Mobileye,
    codigoAccion: CodigoAccion.Consultar,
  };
  permisosPeajes: any = {
    funcionalidad: Funcionalidades.Peajes,
    codigoAccion: CodigoAccion.Consultar,
  };
  permisosMultiFlota: any = {
    funcionalidad: Funcionalidades.MultiFlota,
    codigoAccion: CodigoAccion.Consultar,
  };
  permisosAvlTrack: any = {
    funcionalidad: Funcionalidades.AvlTrack,
    codigoAccion: CodigoAccion.Consultar,
  }

  cantidadAplicaciones: number = 0;
  showActualizarDatos: boolean = false;
  edit_mail: string = null;
  edit_telefono: string = null;
  nombre: string = '';

  token: string = '';



  //FILTROS
  filtroGrillaFechaD = moment(new Date())
    .toISOString()
    .substr(0, 10);
  filtroGrillaFechaH: any = new Date().toISOString().substr(0, 10);
  menuDatePickerFechaD: boolean = false;
  menuDatePickerFechaH: boolean = false;
  time1: any = moment()
    .utc()
    .hour(0)
    .minute(0)
    .toISOString()
    .substr(11, 5);
  time2: any = moment()
    .utc()
    .hour(23)
    .minute(59)
    .toISOString()
    .substr(11, 5);
  menu1: boolean = false;
  menu2: boolean = false;
  btnDisabled: boolean = false;
  cargas: any = null;
  cargasFilter: any = null;
  loadingService = new LoadingService();
  clienteId: number = config.getClienteSesion();
  user_email: string = JSON.parse(window.localStorage.getItem('user')).email
  profiles_allowed: any = [
    'Ejecutivo', 'root'
  ];
  url_avl_track: string = process.env.VUE_APP_URL_AVL_TRACK
  async mounted() {
    //this.loadingService.hideLoading();
    this.validaPermisos();
    this.elementosInformacion = await fetchDashboard(
      { type: 'mensaje' },
      'pantalla/get_pantallas'
    )
      .then((x: any) => x.data.data)
      .finally(() => {
        this.loadingService.hideLoading();
      });
    this.getVerificaActualizarDatos();
    console.log(this.url_avl_track);
    this.setToken();
  }
  created() {
    // Mandar al login si el usuario no existe en caché
    if(store.state.user == null){
      window.localStorage.removeItem("token");
      this.$store.dispatch('logout');
    }
    
    filtroHomeEventBus.$on('clienteMultiApp', (clienteId: number) => {
      (this.clienteId = clienteId), this.validaPermisos();
    });
  }

  get getProfile(){
    const userProfile: any = store.state.user.permisosUsuario.some(
        (x: any) =>
            x.perfilId == 2 || x.perfilId == 5
    );
    console.log(userProfile);
    return userProfile;
  }
  validaPermisos() {
    this.cantidadAplicaciones = 0;
    this.mostrarTrack = this.cargaPermisos(this.permisosTrack);
    this.mostrarAlertas = this.cargaPermisos(this.permisosAlertas);
    this.mostrarCamaras = this.cargaPermisos(this.permisosCamaras);
    this.mostrarCosecha = this.cargaPermisosPropios(this.permisosCosecha);
    this.mostrarDashboard = this.cargaPermisos(this.permisosDashboard);
    this.mostrarDirector = this.cargaPermisos(this.permisosDirector);
    this.mostrarMobileye = this.cargaPermisos(this.permisosMobileye);
    this.mostrarOrvis = this.cargaPermisos(this.permisosOrvis);
    this.mostrarPeajes = this.cargaPermisos(this.permisosPeajes);
    this.mostrarRoutePlanner = this.cargaPermisos(this.permisosRoutePlanner);
    this.mostrarVigilanti = this.cargaPermisos(this.permisosVigilanti);
    this.mostrarMultiflota = this.cargaPermisos(this.permisosMultiFlota);
    this.mostrarAnglo = this.permisosAnglo();
    this.mostrarVendimia = this.permisosVendimia();
    this.mostrarAvlTrack = this.cargaPermisos(this.permisosAvlTrack);
  }

  permisosAnglo() {
    var anglo = [3176, 3275, 4030, 5225, 15711, 16342];
    var existe = anglo.find((a: any) => a == this.clienteId);
    if (existe) this.cantidadAplicaciones++;
    if (existe !== undefined && existe !== null) {
      return true;
    }
    return false;
  }
  permisosVendimia() {
    if (this.clienteId == 2849) {
      this.cantidadAplicaciones++;
      return true;
    }
    return false;
  }

  cargaPermisos(modulo: any): boolean {
    const accion: any = this.usuario.permisosUsuario.find(
      (x: any) =>
        x.moduloCodigo === modulo.funcionalidad &&
        x.accionCodigo === modulo.codigoAccion
    );
    if (accion !== undefined && accion !== null) {
      return true;
    }

    return false;
  }
  cargaPermisosPropios(modulo: any): boolean {
    const accion: any = this.usuario.permisosUsuario.find(
      (x: any) =>
        x.moduloCodigo === modulo.funcionalidad &&
        x.accionCodigo === modulo.codigoAccion
    );
    if (accion !== undefined && accion !== null) {
      this.cantidadAplicaciones++;
      return true;
    }

    return false;
  }
  get appNames(): any[] {
    return this.$store.getters.getApplicationNames;
  }

  async getVerificaActualizarDatos() {
    let resp: any = (await this.VerificaActualizarDatos()) || [];
    console.log(resp);
    if (resp.data.CODIGO_RESPUESTA == '1') {
      this.showActualizarDatos = resp.data.show_modal;
      this.edit_mail = resp.data.edit_mail;
      this.edit_telefono = resp.data.edit_telefono;
      this.nombre = resp.data.data.dataR;
    } else {
      console.log('Sucursal virtual: ' + resp.data.MENSAJE_RESPUESTA);
      this.loadingService.hideLoading();
    }
  }
  handleCierreModalActualizar() {
    this.showActualizarDatos = false;
  }

  VerificaActualizarDatos() {
    let body: any = {};
    let self = this;
    body.user_id = JSON.parse(window.localStorage.user).id;
    return fetchMS(body, 'VerificaActualizarDatos')
      .catch((error: any) => {
        console.log(error);
        self.$snotify.error('Ocurrió un error. Intente nuevamente.', {
          timeout: 3000,
        });
      })
      .finally(() => {
        self.loadingService.hideLoading();
      });
  }

  async setToken() {
    let self = this;

    let LS = {
      user_id: JSON.parse(window.localStorage.getItem('user')).id,
      clienteDefecto: window.localStorage.getItem('clienteDefecto'),
      tokenLogin: window.localStorage.getItem('token')
    }

    let body: any = {
      user_id: LS.user_id,
      LS: LS
    };
    let response: any = await fetchMSGeneral(body, 'navman_vehicle_properties/getToken').catch((error: any) => {
      console.log(error);
      self.$snotify.error('Ocurrió un error. Intente nuevamente.', {
        timeout: 3000,
      });
    }).finally(() => {
      self.loadingService.hideLoading();
    });
    this.token = encodeURIComponent(response.data.token);
    // console.log(this.token);
  }
  getCurrentToken(){
    this.setToken()
    return this.token;
  }
}
